// èç³»ä¿¡æ¯
export class Contact {
  name: string
  email: string
  phone?: string
  address?: string
}
